/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

import Modal from "@mui/material/Modal";

// Dashboard example components

import IconButton from "@mui/material/IconButton";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";

// Functions from store
import {
  getPdi,
  getInventoryAgeingReportHome,
  getExpandedInventoryReportHome,
} from "../../store";
import DataTable from "examples/Tables/DataTable";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const PdiItemAgeingHomePageCard = ({
  getInventoryAgeingReportHome,
  getInventoryAgeingReportHomeReducer,
  getExpandedInventoryReportHome,
  getExpandedInventoryReportHomeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  useEffect(() => {
    getInventoryAgeingReportHome(jwtToken);
    getExpandedInventoryReportHome(jwtToken);
  }, []);

  const [inventoryAgeingTitle, setInventoryAgeingTitle] = useState("");

  const [inventoryAgeingData, setInventoryAgeingData] = useState([]);

  const [expandedInventoryData, setExpandedInventoryData] = useState([]);

  // useEffect(() => {
  //   let data =
  //     getInventoryAgeingReportHomeReducer?.inventoryAgeing?.data ??
  //     getInventoryAgeingReportHomeReducer?.inventoryAgeing ??
  //     [];

  //   let expandData =
  //     getExpandedInventoryReportHomeReducer?.expandedInventory?.data ??
  //     getExpandedInventoryReportHomeReducer?.expandedInventory ??
  //     [];

  //   setInventoryAgeingData(data);
  //   // setExpandedInventoryData(expandData);

  //   setInventoryAgeingTitle(
  //     getInventoryAgeingReportHomeReducer?.inventoryAgeing?.data?.title
  //   );
  // }, [
  //   getInventoryAgeingReportHomeReducer,
  //   getExpandedInventoryReportHomeReducer,
  // ]);

  // const chartData = {
  //   labels: inventoryAgeingData
  //     ? inventoryAgeingData.map((data) => String(data.label))
  //     : [],
  //   datasets: {
  //     label: "Efficiency",
  //     data: inventoryAgeingData
  //       ? inventoryAgeingData.map((data) => Number(data.value))
  //       : [],
  //     backgroundColor: "rgba(75, 192, 192, 0.2)",
  //     borderColor: "rgba  (75, 192, 192, 1)",
  //     borderWidth: 1,
  //   },
  // };

  useEffect(() => {
    let data =
      getInventoryAgeingReportHomeReducer?.inventoryAgeing?.data?.data ??
      getInventoryAgeingReportHomeReducer?.inventoryAgeing?.data ??
      getInventoryAgeingReportHomeReducer?.inventoryAgeing ??
      [];

    let expandData =
      getExpandedInventoryReportHomeReducer?.expandedInventory?.data ??
      getExpandedInventoryReportHomeReducer?.expandedInventory ??
      [];

    setInventoryAgeingData(data);
    setExpandedInventoryData(expandData);

    setInventoryAgeingTitle(
      getInventoryAgeingReportHomeReducer?.inventoryAgeing?.data?.reportTitle ??
        ""
    );
  }, [
    getInventoryAgeingReportHomeReducer,
    getExpandedInventoryReportHomeReducer,
  ]);

  const filteredData = [...inventoryAgeingData].reverse().map((item) => {
    const uom = Object.keys(item)[0];
    const values = item[uom];

    return {
      uom,
      values,
    };
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleChange = (e) => {
    setSelectedIndex(Number(e.target.value));
  };

  // const selectedData = filteredData[selectedIndex]?.values ?? [];
  //  const selectedData = filteredData[selectedIndex]?.values ?? [];
  const selectedDataRaw = filteredData[selectedIndex]?.values;
  const selectedData = Array.isArray(selectedDataRaw) ? selectedDataRaw : [];

  // const chartData = {
  //   labels: selectedData.map((data) => String(data.label)),
  //   datasets: {
  //     label: "Inventory Ageing",
  //     data: selectedData.map((data) => Number(data.value)),
  //     backgroundColor: "rgba(75, 192, 192, 0.2)",
  //     borderColor: "rgba(75, 192, 192, 1)",
  //     borderWidth: 1,
  //   },
  // };

  const chartData = {
    labels: selectedData.map((data) => String(data.label ?? "")),
    datasets: {
      label: "Inventory Ageing",
      data: selectedData.map((data) => Number(data.value ?? 0)),
      backgroundColor: "rgba(75, 192, 192, 0.2)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
  };

  const styleForStationModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, lg: 1100 },
    boxShadow: 24,
    p: 0,
    pt: 3,
  };
  // const chartData = {
  //   labels: ["1 Day", "1 Week", "1 Month", "3 Month"],

  //   // labels: ["1hr", "3 hr", "5 hr", "8 hr"],
  //   datasets: {
  //     label: "Efficiency",
  //     data: [30, 60, 90, 120],
  //   },
  //   title: "Inventory Ageing ",
  // };

  const [state, setState] = useState({
    columns: [
      // { Header: "Item Code", accessor: "assembly" },
      // { Header: "Desc", accessor: "assemblyType" },
      // { Header: "OUM", accessor: "item" },
      // { Header: "Type", accessor: "warehouse" },
      // { Header: "qty", accessor: "zone" },
      // { Header: "WH", accessor: "zonex" },
    ],
    rows: [
      // {
      //   assembly: "ITM-001",
      //   assemblyType: "Widget A",
      //   item: 23,
      //   warehouse: "Type-X",
      //   zone: 120,
      //   zonex: "WH01",
      //   action: "Edit",
      // },
      // {
      //   assembly: "ITM-002",
      //   assemblyType: "Gadget B",
      //   item: 23,
      //   warehouse: "Type-Y",
      //   zone: 85,
      //   zonex: "WH02",
      //   action: "Edit",
      // },
      // {
      //   assembly: "ITM-003",
      //   assemblyType: "Component C",
      //   item: 23,
      //   warehouse: "Type-Z",
      //   zone: 40,
      //   zonex: "WH03",
      //   action: "Edit",
      // },
    ],
  });

  const columns = [
    { Header: "Item Code", accessor: "assembly" },
    { Header: "Desc", accessor: "assemblyType" },
    { Header: "UOM", accessor: "item" },
    { Header: "Type", accessor: "warehouse" },
    { Header: "qty", accessor: "zone" },
    { Header: "WH", accessor: "zonex" },
  ];

  useEffect(() => {
    const rawData = expandedInventoryData;

    const formatted = rawData.map((item) => ({
      assembly: item.itemCode,
      assemblyType: item.description,
      item: item.uom,
      warehouse: item.itemType,
      zone: item.qty,
      zonex: item.warehouseCode,
    }));

    setState((prev) => ({
      ...prev,
      rows: formatted,
    }));
  }, [expandedInventoryData]);

  const { rows } = state;

  const [stationModal, setOpenStationModal] = useState(false);

  const handleOpenStationModal = () => {
    setOpenStationModal(true);
  };
  const handleCloseStationModal = () => {
    setOpenStationModal(false);
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const styles = {
    iconButton: {
      marginLeft: "10px",
      padding: "12px",
      borderRadius: "50%",
      backgroundColor: isHovered ? "#E30B5C" : "#E30B5C",
      color: "white",
      boxShadow: isFocused
        ? "0 0 0 4px rgba(38, 143, 255, 0.5)"
        : "0 4px 12px rgba(0, 123, 255, 0.3)",
      transition: "all 0.3s ease-in-out",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isHovered ? "scale(1.1)" : "scale(1)",
    },
  };

  return (
    <>
      <ReportsBarChart
        color="primary"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "primary" }}
            >
              {inventoryAgeingTitle
                ? inventoryAgeingTitle
                : "Inventory Ageing Report"}
            </span>

            {/* Dropdown for UOM */}
            <FormControl
              variant="outlined"
              size="small"
              style={{ minWidth: 150, borderRadius: 5 }}
            >
              <InputLabel id="uom-select-label" shrink>
                UOM
              </InputLabel>
              <Select
                labelId="uom-select-label"
                value={selectedIndex}
                onChange={handleChange}
                label="UOM"
              >
                {filteredData.map((item, index) => (
                  <MenuItem key={item.uom} value={index}>
                    {item.uom}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <IconButton
              style={styles.iconButton}
              onClick={handleOpenStationModal}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label="Expand"
            >
              <AspectRatioIcon />
            </IconButton>
          </div>
        }
        chart={chartData}
      />

      <Modal
        open={stationModal}
        onClose={handleCloseStationModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={styleForStationModal}>
          <MDBox ml={3} mt={-1} display="flex" alignItems="center">
            <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
              Inventory
            </MDTypography>

            <MDBox display="flex" marginLeft="auto">
              <span>
                {/* <Tooltip title="Close"> */}
                <IconButton
                  style={{
                    display: "flex",
                    background: "whitesmoke",
                    color: "black",
                    borderRadius: 5,
                    marginLeft: "auto",
                    marginBottom: "5px",
                    marginRight: "10px",
                  }}
                  aria-label="close"
                  color="inherit"
                  onClick={handleCloseStationModal}
                >
                  <CloseIcon />
                </IconButton>
                {/* </Tooltip> */}
              </span>
            </MDBox>
          </MDBox>
          <hr style={{ marginBottom: "1rem" }} />
          <MDBox>
            {/* {loading ? ( */}
            <DataTable
              table={{ columns, rows }}
              isSorted={true}
              tableSearch={true}
              entriesPerPage={{
                defaultValue: 5,
                entries: [5, 10, 15, 20, 25, 30],
              }}
              showTotalEntries={true}
              noEndBorder
              hideColumns={["createdDate"]}
            />
          </MDBox>
        </MDCard>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    pdi: state.getPdiHomePage,

    getInventoryAgeingReportHomeReducer:
      state.getInventoryAgeingReportHomeReducer,

    getExpandedInventoryReportHomeReducer:
      state.getExpandedInventoryReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPdi: () => dispatch(getPdi()),

    getInventoryAgeingReportHome: (jwtToken) =>
      dispatch(getInventoryAgeingReportHome(jwtToken)),

    getExpandedInventoryReportHome: (jwtToken) =>
      dispatch(getExpandedInventoryReportHome(jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdiItemAgeingHomePageCard);
